<template>
  <generic-modal
    size="large"
    :title="$t('visanet transaction')"
    icon="credit card"
    image="/images/icons/credit_card.png"
    :show_ok="false"
    :scrolling="true"
    v-on:destroy="$emit('close')"
    :footer_buttons="footer_buttons"
  >
    <div class="description">
      <div class="ui grid">
        <div class="twelve wide column">
          <h2 class="ui small header">
            <i class="exchange icon"></i>
            <div class="content">
              {{ $t("id") }} {{ transaction.uuid }}
              <div class="sub header">
                {{
                  transaction.create_date
                    | formatDate(enterprise_setup.detailed_date_format)
                }}
              </div>
            </div>
          </h2>
        </div>
        <div class="four wide column">
          <h2
            class="ui right floated small header"
            v-bind:class="{
              green: transaction.status_code == 'P',
              red: transaction.status_code == 'E',
            }"
          >
            <i
              class="icon"
              v-bind:class="{
                'green check': transaction.status_code == 'P',
                'red remove': transaction.status_code == 'E',
              }"
            ></i>
            <div class="content">
              {{ transaction.status_code | translate_status(this) }}
              <div class="sub header">
                <strong>{{
                  transaction.type_code | translate_type(this)
                }}</strong>
              </div>
            </div>
          </h2>
        </div>
      </div>
      <div class="ui top attached tabular menu" ref="tabs">
        <a class="active item" data-tab="request">{{ $t("request") }}</a>
        <a class="item" data-tab="response">{{ $t("response") }}</a>
        <a
          class="item"
          data-tab="reverse"
          v-show="
            transaction &&
              transaction.vis_reverses &&
              transaction.vis_reverses.length
          "
          >{{ $t("reverse") }}</a
        >
        <a
          class="item"
          data-tab="void"
          v-show="
            transaction && transaction.vis_voids && transaction.vis_voids.length
          "
          >{{ $t("void") }}</a
        >
      </div>
      <request
        class="ui bottom attached active tab segment"
        data-tab="request"
        :transaction="transaction"
      >
      </request>
      <response
        class="ui bottom attached tab segment"
        data-tab="response"
        :transaction="transaction"
      >
      </response>
      <reverse
        class="ui bottom attached tab segment"
        data-tab="reverse"
        :transaction="transaction"
        v-show="
          transaction &&
            transaction.vis_reverses &&
            transaction.vis_reverses.length
        "
      >
      </reverse>
      <voided
        class="ui bottom attached tab segment"
        data-tab="void"
        :transaction="transaction"
        v-show="
          transaction && transaction.vis_voids && transaction.vis_voids.length
        "
      >
        <pre> {{ transaction.vis_voids }} </pre>
      </voided>
    </div>
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import { local_api, stringify, enterprise_setup, success_toast } from "@/utils";
import filters from "@/filters";
import { translate_status, translate_type } from "../local_translator";
import Request from "./Request.vue";
import Response from "./Response.vue";
import Reverse from "./Reverse.vue";
import Voided from "./Void.vue";

filters.translate_status = translate_status;
filters.translate_type = translate_type;

export default {
  name: "VisaPaymentTransactionModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
    Request,
    Response,
    Reverse,
    Voided,
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      transaction: { request_data: {}, response_data: {} },
      footer_buttons: [],
    };
  },
  methods: {
    updateTransaction(transaction_uuid) {
      let vm = this;
      local_api(this, "post", "/visa_payment/transaction/do-get", {
        u: transaction_uuid,
      })
        .then((tx) => {
          vm.transaction = tx;
          vm.footer_buttons.push({
            text: vm.$t("void"),
            color: "orange",
            icon: "stamp",
            click: vm.void,
            visibility_condition:
              vm.transaction &&
              vm.transaction.type_code &&
              vm.transaction.status_code &&
              vm.transaction.type_code == "S" &&
              vm.transaction.status_code == "P" &&
              vm.transaction.response_data &&
              vm.transaction.response_data.result &&
              vm.transaction.response_data.result.response &&
              vm.transaction.response_data.result.response.responseCode == "00"
                ? true
                : false,
          });
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    },
    void() {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to void transaction?"),
        function() {
          local_api(vm, "post", "/visa_payment/transaction/do-void", {
            u: vm.transaction.uuid,
          })
            .then(() => {
              vm.footer_buttons = [];
              success_toast(vm.$t("void succeeded"));
            })
            .catch((err) => {
              vm.$alertify.error(stringify(err));
            });
        },
      );
    },
  },
  mounted() {
    let vm = this;
    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();
  },
  watch: {},
  updated: function() {},
};
</script>
